import type { FC } from 'react';
import clsx from 'clsx';

export type ResizeHandleSide = 'left' | 'right' | 'bottom';

export interface ResizeHandleProps {
  side: ResizeHandleSide;
  onPointerDown: (e: React.PointerEvent) => void;
}

/**
 * Resize handle component for drag-to-resize functionality.
 * Place on left/right/bottom edges of resizable containers.
 */
export const ResizeHandle: FC<ResizeHandleProps> = ({ side, onPointerDown }) => {
  const isVertical = side === 'bottom';

  return (
    <div
      className={clsx(
        'absolute flex items-center justify-center',
        'opacity-50 group-hover:opacity-100 transition-opacity',
        isVertical ? 'left-0 right-0 bottom-0 h-4 cursor-ns-resize' : 'top-0 bottom-0 w-4 cursor-ew-resize',
        side === 'left' && 'left-0',
        side === 'right' && 'right-0',
      )}
      onPointerDown={onPointerDown}
    >
      <div className={clsx('bg-dark-200 border border-dark-900 rounded-full', isVertical ? 'h-2 w-12' : 'w-2 h-12')} />
    </div>
  );
};
